<template lang="pug">
  card-info(title="Itens do produto" icon="fas fa-shapes")
    .card-body(slot="card-body")
      | Retorna um arquivo #[code .xml] com os itens dos produtos (capítulos, artigos, vídeos)
      .divider
      .columns
        .column.col-12
          form-group(label="Coleção")
            collection-picker(v-model="q.collection" inputSm)
        .column.col-12
          form-group(label="Tipos de itens")
            select.form-select.select-sm(v-model="q.productType")
              option(:value="undefined")
                | Todos
              option(value="magazine")
                | Artigos
              option(value="book")
                | Capítulos de livro
              option(value="video")
                | Vídeos
        .column.col-6
          form-group(label="Publicado início")
            datepicker(input-class="input-sm form-input" v-model="q.publishDateStart")
        .column.col-6
          form-group(label="Publicado fim")
            datepicker(input-class="input-sm form-input" v-model="q.publishDateEnd")
    .card-footer.text-right(slot="card-footer")
      a.btn.btn-error.btn-sm(:class="{ loading }" :disabled="loading" @click="runReport")
        i.fas.fa-play
        |  Gerar relatório
</template>

<script>
import xmlReports from '@/services/xmlReports'

export default {
  data() {
    return { loading: false, q: {} }
  },
  methods: {
    async runReport() {
      try {
        this.loading = true
        await xmlReports.productItems(this.q)
      } catch (e) {
        this.$toaster.error(e.message)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
